import { AxiosResponse, AxiosError, AxiosRequestConfig } from 'axios'
import merge from 'lodash/merge'
import { IApiValidationError } from './IApiValidationError.model'

export interface IApiErrorResponse extends AxiosResponse {
    status: number
    data: {
        errorCode: number
        errorText: string
        errorType: string
        errorDetails?: Record<string, unknown>
        validationErrors: IApiValidationError[]
    }
}

export class ApiError {
    public code?: string
    public name: string
    public message: string
    public config: AxiosRequestConfig
    public request?: any
    public response: IApiErrorResponse
    public isAxiosError: boolean

    constructor(error: AxiosError) {
        this.code = error.code
        this.name = error.name || 'ApiError'
        this.message = error.message || 'API error'
        this.config = error.config || {}
        this.request = error.request
        this.response = merge(this.defaultResponse, error.response)
        this.isAxiosError = error.isAxiosError || false
    }

    private get defaultResponse(): IApiErrorResponse {
        return {
            status: 0,
            data: {
                errorCode: 0,
                errorText: this.message,
                errorType: this.name,
                validationErrors: [],
            },
            statusText: '',
            headers: undefined,
            config: {},
        }
    }
}
